import { RowNode } from "ag-grid-community";
import { sum } from "lodash";
import React from "react";
import { RowData } from "./types";
import { NoTranslate } from "@/components/Common/NoTranslate";

export const equipmentCellValueGetter = ({ data }: { data: RowData }) => {
    if ("itemEquipments" in data && data.itemEquipments) {
        return Object.values(data.itemEquipments.value).reduce((sum: number, v) => sum + (v as number), 0);
    }
    return 0;
};

export const EquipmentCellRenderer = ({ data, node }: { data: RowData; node: RowNode }) => {
    // Summary row (collapsed header): show aggregated equipment counts
    if (node.key === "summary" && "equipments" in data) {
        const eq = data.equipments;
        if (!eq || eq.length === 0) return null;
        if (!node.expanded) {
            const totalQuantity = sum(Object.values(eq.value) as number[]);
            return <NoTranslate as="span">{totalQuantity} Equipment units</NoTranslate>;
        }
        return (
            <ul className="mb-2 mt-2 leading-5">
                {Object.entries(eq.value).map(([name, qty]) => (
                    <li key={name} className="flex items-center space-x-1">
                        <NoTranslate as="span">
                            {qty} {name}
                        </NoTranslate>
                    </li>
                ))}
            </ul>
        );
    }

    const equipment = "itemEquipments" in data ? data.itemEquipments : undefined;
    if (!equipment || equipment.length === 0) return null;

    return (
        <ul className="mb-2 mt-2 leading-5">
            {Object.entries(equipment.value).map(([name, qty]) => (
                <li key={name} className="flex items-center space-x-1">
                    <NoTranslate as="span">
                        {qty} {name}
                    </NoTranslate>
                </li>
            ))}
        </ul>
    );
};
